import script from "./articleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./articleCard.vue?vue&type=script&setup=true&lang=js"

import "./articleCard.vue?vue&type=style&index=0&id=3eb8c212&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb8c212"]])

export default __exports__